import React, { Component } from 'react'
import CompanyItemCard from 'containers/CompanyContainer/CompanyItemCard';
import styled, {css} from 'styled-components'
import PropTypes from 'prop-types';

export const EmployeeCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    margin-right: 10%;
`

const StaffCardContainer = (props) => {
    const { employee, index, services, type, onClick, onProviderClick } = props;
    return (
        <EmployeeCardWrapper key={employee.first +index+ employee.last}>

            <CompanyItemCard
                type={'employee'}
                name={employee.name}
                onClick={onProviderClick
                    ? () => onProviderClick(employee.uid)
                    : () => onClick('staff', employee)
                }
                img={employee.profilePhotoURL}
            />

            {Object.keys(employee.services || {}).map((service, index) => {
                let serviceInfo = services[service];
                if(serviceInfo){
                    return(
                        <CompanyItemCard
                            key = {`${service.name}${index}`}
                            name={serviceInfo.name}
                            type={'service'}
                            onClick={() => onClick('SERVICE',serviceInfo)}
                        />
                    )
                } else {
                    return(
                        <CompanyItemCard
                            key = {`unknown${index}`}
                            name={'Unknown service'}
                            type={'service'}
                            onClick={() => null}
                        />
                    )
                }
            })}
        </EmployeeCardWrapper>
    )
}

export default StaffCardContainer;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/StaffCardContainer.jsx